import * as z from "zod/v4";

// SHA256 hash schema (52 base32 characters)
// 256 bits / 5 bits per base32 char = 51.2, padded to 52 chars
export const Sha256Schema = z
  .string()
  .regex(/^[a-z2-7]{52}$/, "SHA256 hash must be 52 lowercase base32 characters")
  .describe("SHA256 hash of file contents (base32 encoded)");
export type Sha256 = z.infer<typeof Sha256Schema>;
